<div class="flex h-full flex-col px-3 py-2">
  <div class="shrink-0 mb-2">
    <h2 class="text-sm font-semibold text-slate-700">Desglose de cobranza</h2>
    <p class="text-base font-bold text-slate-900 mt-0.5 tabular-nums">
      {{ formatCurrency(combinedTotal()) }}
    </p>
    <p class="text-xs text-slate-400">Facturas del período: cobrado vs pendiente</p>
  </div>
  <div class="flex-1 min-h-0">
    <p-chart class="block h-full w-full" type="bar" [data]="chartData()" [options]="chartOptions" />
  </div>
</div>